module.exports = __webpack_public_path__ + "img/sport-logo.cebfdc2d.png";